import React from 'react';
import { StyleSheet, Text } from '@react-pdf/renderer';
import { contractTemplateType } from '../../NewContractModal/SelectContractTemplate/SelectContractTemplate';

const styles = StyleSheet.create({
  contractParagraph: {
    fontSize: 14,
    marginBottom: 16,
  },
});

export default function ReactPdfPaymentTermsFromTemplate({ meta, contractTemplate, formData }) {
  const extractTextContent = (htmlString) => {
    const tempDiv = document.createElement('div');
    // Replace <br> tags with newline characters
    tempDiv.innerHTML = htmlString.replace(/<br\s*\/?>/gi, '\n\n');
    return tempDiv.textContent || tempDiv.innerText || ''; // Use textContent if available, fallback to innerText for older browsers
  };

  return (
    <>
      <Text style={{ fontSize: 14 }}>{extractTextContent(formData.paymentTerms)}</Text>
    </>
  );
}
